// extracted by mini-css-extract-plugin
export default {"mainCont":"StaffOrderHistory_mainCont__80TZi","TableDiv":"StaffOrderHistory_TableDiv__3qthi"};